import React, { useRef, useState } from 'react'
import emailjs from '@emailjs/browser'
import PageHeader from '../Shared/PageHeader'
import toast from 'react-hot-toast'
import { MdOutlineEmail, MdLocationOn } from 'react-icons/md'
import { BsCircleFill } from 'react-icons/bs'
import { IoSendSharp } from 'react-icons/io5'

const FloatingField = ({ label, name, type = 'text', required, multiline }) => {
  const [focused, setFocused] = useState(false)
  const [hasValue, setHasValue] = useState(false)
  const active = focused || hasValue
  const Tag = multiline ? 'textarea' : 'input'

  return (
    <div style={{ position: 'relative', paddingTop: '18px' }}>
      <label
        style={{
          position: 'absolute',
          left: 0,
          top: active ? '0px' : multiline ? '26px' : '26px',
          fontSize: active ? '10px' : '13px',
          color: focused
            ? '#facc15'
            : active
              ? 'rgba(250,204,21,0.5)'
              : '#4b5563',
          fontWeight: 600,
          letterSpacing: active ? '0.12em' : '0.04em',
          textTransform: 'uppercase',
          transition: 'all 0.22s ease',
          pointerEvents: 'none',
          zIndex: 1
        }}>
        {label}
      </label>
      <Tag
        type={type}
        name={name}
        required={required}
        rows={multiline ? 4 : undefined}
        onFocus={() => setFocused(true)}
        onBlur={(e) => {
          setFocused(false)
          setHasValue(!!e.target.value)
        }}
        onChange={(e) => setHasValue(!!e.target.value)}
        style={{
          width: '100%',
          background: 'transparent',
          border: 'none',
          borderBottom: `1.5px solid ${focused ? '#facc15' : 'rgba(255,255,255,0.08)'}`,
          boxShadow: focused ? '0 2px 0 rgba(250,204,21,0.3)' : 'none',
          padding: '10px 0 8px',
          color: '#e2e8f0',
          outline: 'none',
          fontSize: '14px',
          fontFamily: 'Space Grotesk, sans-serif',
          resize: 'none',
          transition: 'border-color 0.25s ease, box-shadow 0.25s ease',
          display: 'block',
          boxSizing: 'border-box'
        }}
      />
    </div>
  )
}

const InfoRow = ({ icon: Icon, label, value, color }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px',
      padding: '10px 0'
    }}>
    <div
      style={{
        width: '34px',
        height: '34px',
        borderRadius: '8px',
        flexShrink: 0,
        background: `${color}12`,
        border: `1px solid ${color}30`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
      <Icon style={{ color, fontSize: '16px' }} />
    </div>
    <div>
      <p
        style={{
          color: '#4b5563',
          fontSize: '10px',
          fontWeight: 600,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          margin: 0
        }}>
        {label}
      </p>
      <p style={{ color: '#d1d5db', fontSize: '13px', margin: '2px 0 0' }}>
        {value}
      </p>
    </div>
  </div>
)

const Contact = () => {
  const form = useRef()
  const [loading, setLoading] = useState(false)
  const [btnHovered, setBtnHovered] = useState(false)

  const sendEmail = (e) => {
    e.preventDefault()
    setLoading(true)
    emailjs
      .sendForm(
        'portfolio_contact007',
        'template_33ijts6',
        form.current,
        'M--wbuo_HrNvDpS_c'
      )
      .then(
        () => {
          toast.success('Message sent!')
          e.target.reset()
          setLoading(false)
        },
        () => {
          setLoading(false)
          toast.error('Something went wrong. Try again.')
        }
      )
  }

  return (
    <div>
      <PageHeader title='Contact' />

      <div
        style={{
          marginTop: '32px',
          display: 'grid',
          gridTemplateColumns: '1fr',
          gap: '32px'
        }}>
        {/* top info strip */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
            gap: '12px'
          }}>
          {/* availability badge */}
          <div
            style={{
              padding: '14px 18px',
              borderRadius: '12px',
              background: 'rgba(37,211,102,0.06)',
              border: '1px solid rgba(37,211,102,0.18)',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
            <BsCircleFill
              style={{
                color: '#25D366',
                fontSize: '8px',
                animation: 'pulse-dot 2s ease-in-out infinite'
              }}
            />
            <div>
              <p
                style={{
                  color: '#25D366',
                  fontSize: '11px',
                  fontWeight: 700,
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase',
                  margin: 0
                }}>
                Status
              </p>
              <p
                style={{
                  color: '#9ca3af',
                  fontSize: '12px',
                  margin: '2px 0 0'
                }}>
                Available for work
              </p>
            </div>
          </div>

          <InfoRow
            icon={MdOutlineEmail}
            label='Email'
            value='shipatulhasan328@gmail.com'
            color='#facc15'
          />
          <InfoRow
            icon={MdLocationOn}
            label='Location'
            value='Chattogram, Bangladesh'
            color='#818cf8'
          />
        </div>

        {/* divider */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
          <div
            style={{
              flex: 1,
              height: '1px',
              background:
                'linear-gradient(90deg, transparent, rgba(250,204,21,0.2))'
            }}
          />
          <span
            style={{
              color: '#374151',
              fontSize: '11px',
              fontWeight: 600,
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              whiteSpace: 'nowrap'
            }}>
            Send a message
          </span>
          <div
            style={{
              flex: 1,
              height: '1px',
              background:
                'linear-gradient(90deg, rgba(250,204,21,0.2), transparent)'
            }}
          />
        </div>

        {/* form */}
        <form ref={form} onSubmit={sendEmail}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '0 24px',
              marginBottom: '8px'
            }}>
            <FloatingField label='Your Name' name='client_name' required />
            <FloatingField
              label='Email Address'
              name='email'
              type='email'
              required
            />
          </div>

          <div style={{ marginTop: '16px' }}>
            <FloatingField label='Message' name='message' required multiline />
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: '28px'
            }}>
            <button
              type='submit'
              disabled={loading}
              onMouseEnter={() => setBtnHovered(true)}
              onMouseLeave={() => setBtnHovered(false)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '10px',
                padding: '12px 28px',
                borderRadius: '10px',
                border: btnHovered
                  ? '1px solid #facc15'
                  : '1px solid rgba(250,204,21,0.3)',
                background: btnHovered
                  ? 'linear-gradient(135deg, rgba(250,204,21,0.18), rgba(250,204,21,0.06))'
                  : 'rgba(250,204,21,0.06)',
                color: btnHovered ? '#facc15' : '#9ca3af',
                fontWeight: 700,
                fontSize: '12px',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                fontFamily: 'Space Grotesk, sans-serif',
                boxShadow: btnHovered
                  ? '0 0 24px rgba(250,204,21,0.22)'
                  : 'none',
                transform: btnHovered ? 'translateY(-2px)' : 'translateY(0)',
                transition: 'all 0.25s cubic-bezier(0.34,1.56,0.64,1)',
                opacity: loading ? 0.6 : 1
              }}>
              {loading ? (
                <>
                  <span
                    style={{
                      width: '14px',
                      height: '14px',
                      border: '2px solid rgba(250,204,21,0.3)',
                      borderTopColor: '#facc15',
                      borderRadius: '50%',
                      animation: 'spin 0.7s linear infinite',
                      display: 'inline-block'
                    }}
                  />
                  Sending…
                </>
              ) : (
                <>
                  <IoSendSharp
                    style={{
                      fontSize: '14px',
                      transform: btnHovered ? 'translate(2px,-2px)' : 'none',
                      transition: 'transform 0.2s ease'
                    }}
                  />
                  Send Message
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Contact
